export default __webpack_public_path__ + "static/media/backbone.7e59b6f7.svg";